import { PhoneOff, Video, Phone } from "lucide-react";

type Props = {
  peerLabel: string;
  media: "audio" | "video";
  onAccept: () => void;
  onReject: () => void;
};

export function ChatIncomingCallBanner({ peerLabel, media, onAccept, onReject }: Props) {
  const initial = peerLabel.trim().slice(0, 1).toUpperCase() || "?";
  const kind = media === "video" ? "Visio entrante" : "Appel entrant";

  return (
    <div className="chat-incoming-banner" role="alertdialog" aria-label="Appel entrant">
      <div className="chat-incoming-card">
        <div className="chat-incoming-top">
          <div className="chat-incoming-avatar" aria-hidden>
            <span className="chat-incoming-avatar-ring" />
            {initial}
          </div>
          <div className="chat-incoming-copy">
            <p className="chat-incoming-kind">{kind}</p>
            <strong>{peerLabel}</strong>
          </div>
        </div>
        <div className="chat-incoming-actions">
          <button
            type="button"
            onClick={onReject}
            className="chat-incoming-action"
            aria-label="Refuser"
          >
            <span className="chat-incoming-action__icon chat-incoming-action__icon--reject">
              <PhoneOff className="size-5" />
            </span>
            <span className="chat-incoming-action__label">Refuser</span>
          </button>
          <button
            type="button"
            onClick={onAccept}
            className="chat-incoming-action"
            aria-label="Accepter"
          >
            <span className="chat-incoming-action__icon chat-incoming-action__icon--accept">
              {media === "video" ? <Video className="size-5" /> : <Phone className="size-5" />}
            </span>
            <span className="chat-incoming-action__label">Accepter</span>
          </button>
        </div>
      </div>
    </div>
  );
}
